// Display name for a Global Search chat: its own label, else a neutral fallback.
// A chat has no items to derive a name from (unlike a searchroom), so the
// fallback is a simple placeholder.
export function globalChatLabel(chat) {
  const own = chat?.label?.trim()
  return own || 'Untitled chat'
}
